import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-135cb5d9"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "nav-bar-list"
};
var _hoisted_2 = ["href"];
var _hoisted_3 = {
  class: "nav-bar-item"
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("a", {
    href: "#活动文件"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "nav-bar-item"
  }, "活动文件")], -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_divider = _resolveComponent("a-divider");
  var _component_CaretLeftOutlined = _resolveComponent("CaretLeftOutlined");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-bar-container", _ctx.visible ? 'visible' : 'hide'])
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [_createElementVNode("a", {
      href: "#".concat(item.navBarName)
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.navBarName), 1)], 8, _hoisted_2), index + 1 < _ctx.list.length ? (_openBlock(), _createBlock(_component_a_divider, {
      key: 0
    })) : _createCommentVNode("", true)], 64);
  }), 128)), _ctx.appendixUrlList && _ctx.appendixUrlList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_divider), _hoisted_5])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "suffix-box",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.toggle && _ctx.toggle.apply(_ctx, args);
    })
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.visible ? '收起' : '展开'), 1), _createVNode(_component_CaretLeftOutlined, {
    rotate: _ctx.visible ? 0 : 180
  }, null, 8, ["rotate"])])], 2);
}